module.exports = require("lodash.intersection");